import React from "react"
import { IScheduleDocument, IScheduleDailyTimelineData, IScheduleShift, IHolidayInstanceForPunch } from "../../../../models"
import moment from "moment"
import WeekTimeline from "./WeekTimeline"
import * as scheduleHelper from "../../../../helpers/scheduleHelper"
import _ from "lodash"
export interface IWeeklyScheduleShift {
	ReferenceDate: Date | string
	Shifts: IScheduleShift[]
}
interface IProps {
	schedules: IScheduleDocument[]
	referenceStartDate: Date | string
	readonly?: boolean
	holidays: IHolidayInstanceForPunch[]
	handleUpdateTimelineData(updateShift: IScheduleShift): void
	checkValidateNewTimeline(shifts: IScheduleShift[], updateShift: IScheduleShift, timelineItem: IScheduleDailyTimelineData): boolean
	handleDeleteTimelineItem(deleteShift: IScheduleShift): void
	handleUpdateTimelineItem(updateShift: IScheduleShift): void
}

export const UserDetailScheduleWeekly: React.SFC<IProps> = (props: IProps) => {
	const virtualTimeShiftsForWeek: IWeeklyScheduleShift[] = []
	for (let i = 0; i < 7; i++) {
		virtualTimeShiftsForWeek.push({
			ReferenceDate: moment(props.referenceStartDate).add(i, "day").format(),
			Shifts: []
		})
	}

	props.schedules.forEach(item =>
		item.Schedules.forEach(pt => {
			const startSimpleTimeOfPT = scheduleHelper.getStartEndSimpleTimeOfPatternTemplate(pt).StartSimpleTime
			const diff = moment(scheduleHelper.getTimeFromSimpleTime(startSimpleTimeOfPT).startOf("day")).diff(props.referenceStartDate, "days")
			if (diff > -1 && diff < 7) {
				scheduleHelper.getVirtualPatternTemplateFromRealPatternTemplate(pt).ShiftTemplates.forEach(st =>
					virtualTimeShiftsForWeek[diff].Shifts.push(st)
				)
			}
		})
	)
	return (
		<WeekTimeline
			readonly={props.readonly}
			weeklyScheduleShifts={virtualTimeShiftsForWeek}
			holidays={props.holidays}
			handleUpdateTimelineData={(timelineItem, rowNumber, orderNumber) => {
				const realPatternTemplateStartDay = virtualTimeShiftsForWeek[rowNumber].ReferenceDate
				const virtualTargetShiftTemplate = virtualTimeShiftsForWeek[rowNumber].Shifts[orderNumber]
				virtualTargetShiftTemplate.StartTime = timelineItem.StartTime
				virtualTargetShiftTemplate.EndTime = timelineItem.EndTime
				virtualTargetShiftTemplate.Breaks = timelineItem.Breaks
				const realTargetShiftTemplate = scheduleHelper.getRealShiftTemplateFromVirtualShiftTemplate(realPatternTemplateStartDay, virtualTargetShiftTemplate)
				props.handleUpdateTimelineData(realTargetShiftTemplate)
			}}
			checkValidateNewTimeline={(timelineItem, rowNumber, orderNumber) => props.checkValidateNewTimeline(virtualTimeShiftsForWeek[rowNumber].Shifts, virtualTimeShiftsForWeek[rowNumber].Shifts[orderNumber], timelineItem)}
			handleDeleteTimelineItem={(rowNumber, orderNumber) => props.handleDeleteTimelineItem(virtualTimeShiftsForWeek[rowNumber].Shifts[orderNumber])}
			handleUpdateTimelineItem={(shift, rowNumber, orderNumber) => {
				const realPatternTemplateStartDay = virtualTimeShiftsForWeek[rowNumber].ReferenceDate
				const realTargetShiftTemplate = scheduleHelper.getRealShiftTemplateFromVirtualShiftTemplate(realPatternTemplateStartDay, shift)
				props.handleUpdateTimelineItem(realTargetShiftTemplate)
			}}
		/>
	)
}

